import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { Anesthetist } from 'types/procedure';
import MoneyInput from 'components/masked-input/MoneyInput';
import { asInputComponent } from 'components/masked-input/asInputComponent';

interface ProcedureAnesthetistFormProps {
  anesthetist: Anesthetist | null;
  handleChangeAnesthetist: (index: keyof Anesthetist, value: any) => void;
}

const ProcedureAnesthetistForm: React.FC<ProcedureAnesthetistFormProps> = ({
  anesthetist,
  handleChangeAnesthetist,
}) => {
  return (
    <Grid container size={12} spacing={2} maxWidth={1200}>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Preço de venda mínimo"
          placeholder="Digite o preço de venda mínimo"
          value={anesthetist?.sale_price_min || 0}
          onChange={e => handleChangeAnesthetist('sale_price_min', e.target.value)}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              inputComponent: asInputComponent(MoneyInput),
            },
          }}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          label="Preço de venda máximo"
          placeholder="Digite o preço de venda máximo"
          value={anesthetist?.sale_price_max || 0}
          onChange={e => handleChangeAnesthetist('sale_price_max', e.target.value)}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
              inputComponent: asInputComponent(MoneyInput),
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default ProcedureAnesthetistForm;
